import type { PendingAction } from '@/types';

interface Props {
  state: string;
  canStart: boolean;
  canStop: boolean;
  pending: PendingAction;
  onStart: () => void;
  onStop: () => void;
}

export default function ActionButtons({ state, canStart, canStop, pending, onStart, onStop }: Props) {
  if (pending === 'start') {
    return (
      <div className="mt-6 rounded-xl bg-white p-6 shadow">
        <button className="btn w-full justify-center gap-2 bg-green-600 text-white hover:bg-green-700" disabled>
          <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
          Starting…
        </button>
      </div>
    );
  }
  if (pending === 'stop') {
    return (
      <div className="mt-6 rounded-xl bg-white p-6 shadow">
        <button className="btn w-full justify-center gap-2 bg-amber-600 text-white hover:bg-amber-700" disabled>
          <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
          Stopping…
        </button>
      </div>
    );
  }

  return (
    <div className="mt-6 grid gap-3 sm:grid-cols-2">
      <button className="btn bg-green-600 text-white hover:bg-green-700 disabled:bg-green-300 disabled:shadow-none" disabled={!canStart} onClick={onStart}>
        Start Server
      </button>
      <button className="btn bg-amber-600 text-white hover:bg-amber-700 disabled:bg-amber-300 disabled:shadow-none" disabled={!canStop} onClick={onStop}>
        Stop Server
      </button>
    </div>
  );
}
